import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { IPKImportLog } from '../../pk';
import { FiPrintDownloadComponent } from '@fi-shared/fi-print-download/fi-print-download.component';
import { AppTextService } from '@fi-shared/app-text';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { PKUsersImportType } from '@fi-app/external-platform-integration/pk/pk-users-import-type';

@Component({
    selector: 'fi-pk-import-log-detailed-dialog',
    template: `
        <div class="detailed-log-container" id="detailed-log-container">
            <fi-pk-log-container [importLog]="data.log" [usersImportType]="data.usersImportType" />
        </div>

        <div class="detailed-log-dialog-footer-container">
            <button
                mat-button
                class="BrandedColor BrandedBorderColor border"
                (click)="downloadLogs(fiPrintDownloadComponentRef)"
            >
                {{ 'pk.import_log_download' | fiAppText }}
            </button>
            <button mat-button class="BrandedBackgroundColor" (click)="close()">
                {{ 'done' | fiAppText }}
            </button>
        </div>

        <fi-print-download
            #fiPrintDownloadComponentRef
            [printElementSelector]="'#detailed-log-container'"
            [downloadFilename]="getFileName()"
        >
        </fi-print-download>
    `,
    styleUrls: ['./pk-import-log-detailed-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'pk-import-log-detailed-dialog' },
    standalone: false,
})
export class PkImportLogDetailedDialogComponent
    extends FiDialogsContentBase<{ log: IPKImportLog; usersImportType: PKUsersImportType }, any>
    implements OnInit
{
    private appTextService: AppTextService;
    private fiFormatDateService: FiFormatDateService;

    ngOnInit(): void {
        this.appTextService = this.injector.get(AppTextService);
        this.fiFormatDateService = this.injector.get(FiFormatDateService);
    }

    downloadLogs(fiPrintDownloadComponentRef: FiPrintDownloadComponent) {
        fiPrintDownloadComponentRef.Download();
    }

    getFileName(): string {
        return `${this.appTextService.get('pk.import_log')} ${this.fiFormatDateService.formatDate(this.data.log.CreatedOn, 'date-time', { showToday: false })}`;
    }

    close() {
        this.dialogRef.close();
    }
}
